var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaperClip(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 96 96",
    style: {
      enableBackground: "new 0 0 96 96"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M51.672,17.82c-7.756,0-14.066,6.31-14.066,14.066v27.967c0,5.731,4.663,10.394,10.394,10.394s10.394-4.662,10.394-10.394 V40.343c0-1.104-0.896-2-2-2s-2,0.896-2,2v19.509c0,3.525-2.868,6.394-6.394,6.394c-3.526,0-6.394-2.868-6.394-6.394V31.886 c0-5.55,4.516-10.066,10.066-10.066c5.55,0,10.065,4.516,10.065,10.066v28.557c0,7.575-6.162,13.737-13.737,13.737 s-13.738-6.162-13.738-13.737V33.867c0-1.104-0.896-2-2-2s-2,0.896-2,2v26.575c0,9.78,7.957,17.737,17.738,17.737 c9.78,0,17.737-7.957,17.737-17.737V31.886C65.737,24.13,59.428,17.82,51.672,17.82z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperClip);
export default __webpack_public_path__ + "static/media/paper-clip.b2bf3ba3683d7677624104d1f5cfb22d.svg";
export { ForwardRef as ReactComponent };